// src/components/layout/AdminHeader.jsx
import React, { useState } from 'react'
import { useAppSelector, useAppDispatch } from '../../hooks/useAppDispatch.js'
import { logout } from '../../redux/slices/authSlice.js'

export default function AdminHeader() {
    const dispatch = useAppDispatch()
    const { user } = useAppSelector((state) => state.auth)
    const [showUserMenu, setShowUserMenu] = useState(false)

    const handleLogout = () => {
        dispatch(logout())
    }

    return (
        <header className="admin-header">
            <div className="flex items-center justify-between px-6 py-4">
                <div>
                    {/* <h1 className="text-2xl font-bold text-gray-900">Admin Dashboard</h1>
                    <p className="text-gray-600 text-sm">Welcome back, {user?.name}</p> */}
                    <button onClick={() => window.history.back()} className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                        {"< Go Back"}
                    </button>
                </div>

                <div className="relative">
                    <button
                        onClick={() => setShowUserMenu(!showUserMenu)}
                        className="flex items-center space-x-3 focus:outline-none"
                    >
                        <div className="text-right hidden md:block">
                            <p className="text-sm font-medium text-gray-900">{user?.name}</p>
                            <p className="text-sm text-gray-600">{user?.email}</p>
                        </div>
                        <div className="w-10 h-10 bg-primary-600 rounded-full flex items-center justify-center text-white font-bold">
                            {user?.name?.charAt(0) || 'A'}
                        </div>
                    </button>

                    {showUserMenu && (
                        <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50 border border-gray-200">
                            <div className="px-4 py-2 border-b border-gray-100 md:hidden">
                                <p className="text-sm font-medium text-gray-900">{user?.name}</p>
                                <p className="text-sm text-gray-600 truncate">{user?.email}</p>
                            </div>
                            <button
                                onClick={handleLogout}
                                className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                            >
                                Logout
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </header>
    )
}